import kitchenInstance from '../instance'

const updateKitchenOrderDisplayStatus = (orderId, data) => {
  return kitchenInstance.put('/orders/' + orderId + '/displayStatus', data)
}

export default updateKitchenOrderDisplayStatus
